import { render, staticRenderFns } from "./xw-modal.vue?vue&type=template&id=291cd0be&scoped=true"
import script from "./xw-modal.vue?vue&type=script&lang=js"
export * from "./xw-modal.vue?vue&type=script&lang=js"
import "./xw-modal.vue?vue&type=style&index=0&id=291cd0be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291cd0be",
  null
  
)

export default component.exports